import { render, staticRenderFns } from "./FundsSpotEx.vue?vue&type=template&id=2eb530c8&scoped=true"
import script from "./FundsSpotEx.vue?vue&type=script&lang=js"
export * from "./FundsSpotEx.vue?vue&type=script&lang=js"
import style0 from "./FundsSpotEx.vue?vue&type=style&index=0&id=2eb530c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb530c8",
  null
  
)

export default component.exports